import { HorizontalFlex, Sect } from "pandora/styled";
import { JSX } from "react";

type InfoFieldProps = {
  header: string;
  value: string | JSX.Element;
};

export const InfoField = ({ header, value }: InfoFieldProps) => {
  return (
    <HorizontalFlex
      key={value?.toString() + header}
      css="font-size: 11px; margin-top: 10px;"
    >
      <Sect css="font-weight: 600; flex: 2">{header}</Sect>
      <Sect
        css="flex: 4; text-align: left;
justify-content: flex-start;
padding-left:4px"
      >
        {value}
      </Sect>
    </HorizontalFlex>
  );
};
